module.exports = __webpack_public_path__ + "img/undraw_learning_2q1h.a4a5aa40.svg";